module.exports = __webpack_public_path__ + "media/images/icon__ranking-634c822f1b216984e29a21f7ef482fee.png";